import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead } from "@/lib/route-head";
const QuizPage = lazy(() => import("@/pages/QuizPage"));

export const Route = createFileRoute("/quiz")({
  head: () => pageHead({
    path: "/quiz",
    title: "Find Your Amorette Experience | Free Quiz",
    description: "Discover curated dinners and shared experiences for intentional connections, friendship and professional networking. Free — no purchase or reservation.",
  }),
  component: QuizPage,
});
